import request from '../api';

export const sendEducationRequest = form => request('panpartner:forms.ajax', 'sendEducationRequest', form);